import {configureCad3d} from './cadConfig';

// A module rather than a statement in the entry: only an import can run before the other
// imports do, and @ergeon/cad must find the version already on the global.
configureCad3d();
